/* BASIIC theme — global.js */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  window.basiic = window.basiic || {};
  const B = window.basiic;

  B.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || window.moneyFormat || '${{amount}}';
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision; thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    const m = formatString.match(placeholderRegex);
    const type = m ? m[1] : 'amount';
    switch (type) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  };

  B.fetchConfig = function (type) {
    return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: `application/${type || 'json'}` } };
  };

  B.debounce = function (fn, wait) {
    let t; return function (...args) { clearTimeout(t); t = setTimeout(() => fn.apply(this, args), wait); };
  };

  /* ---------- drawers ---------- */
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  let openDrawer = null; let lastTrigger = null;

  B.openDrawer = function (id, trigger) {
    const el = document.getElementById(id);
    if (!el) return;
    if (openDrawer && openDrawer !== el) B.closeDrawer(openDrawer.id, false);
    openDrawer = el; lastTrigger = trigger || document.activeElement;
    el.classList.add('is-open'); el.removeAttribute('hidden'); el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    document.querySelectorAll(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const focusTarget = el.querySelector('[data-autofocus]') || el.querySelector(FOCUSABLE);
    setTimeout(() => focusTarget && focusTarget.focus(), 60);
    el.dispatchEvent(new CustomEvent('drawer:open'));
  };
  B.closeDrawer = function (id, restore = true) {
    const el = document.getElementById(id);
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    document.querySelectorAll(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (openDrawer === el) { openDrawer = null; document.body.classList.remove('drawer-open'); }
    if (restore && lastTrigger && lastTrigger.focus) lastTrigger.focus();
    el.dispatchEvent(new CustomEvent('drawer:close'));
  };

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-drawer-open]');
    if (open) { e.preventDefault(); B.openDrawer(open.getAttribute('data-drawer-open'), open); return; }
    const close = e.target.closest('[data-drawer-close]');
    if (close) { e.preventDefault(); const d = close.closest('.drawer'); if (d) B.closeDrawer(d.id); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && openDrawer) { B.closeDrawer(openDrawer.id); return; }
    if (e.key === 'Tab' && openDrawer) {
      const f = Array.from(openDrawer.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Close header dropdowns on outside click */
  document.addEventListener('click', (e) => {
    document.querySelectorAll('details.header__dropdown[open], details.facet[open]').forEach((d) => {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* ---------- cart ---------- */
  B.cart = {
    queue: Promise.resolve(),
    sectionIds() {
      const ids = [];
      if (document.getElementById('shopify-section-cart-drawer')) ids.push('cart-drawer');
      const main = document.querySelector('[data-cart-section-id]');
      if (main) ids.push(main.getAttribute('data-cart-section-id'));
      return ids;
    },
    // Serialise all mutating requests so line indexes/keys never go stale mid-flight.
    enqueue(task) {
      const run = this.queue.then(task, task);
      this.queue = run.catch(() => {});
      return run;
    },
    async request(url, init) {
      const res = await fetch(url, init);
      let json = null;
      try { json = await res.json(); } catch (e) { json = null; }
      if (!res.ok || (json && json.status && json.status >= 400)) {
        throw new Error((json && (json.description || json.message)) || window.shopStrings.cartError);
      }
      return json;
    },
    add(formData) {
      return this.enqueue(async () => {
        const ids = this.sectionIds();
        if (ids.length) { formData.append('sections', ids.join(',')); formData.append('sections_url', window.location.pathname); }
        const json = await this.request(window.routes.cart_add_url + '.js', { method: 'POST', body: formData, headers: { Accept: 'application/javascript' } });
        if (json.sections) this.renderSections(json.sections);
        const cart = await this.refreshCount();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: json, cart } }));
        this.mutated();
        return json;
      });
    },
    change(payload) {
      return this.enqueue(async () => {
        payload.sections = this.sectionIds(); payload.sections_url = window.location.pathname;
        const json = await this.request(window.routes.cart_change_url + '.js', { ...B.fetchConfig(), body: JSON.stringify(payload) });
        this.state = json;
        if (json.sections) this.renderSections(json.sections);
        this.updateCount(json.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: json }));
        this.mutated();
        return json;
      });
    },
    // Raw update: ONLY call from inside an enqueued task (e.g. offer reconciliation) — never enqueue from within.
    async _update(payload) {
      payload.sections = this.sectionIds(); payload.sections_url = window.location.pathname;
      const json = await this.request(window.routes.cart_update_url + '.js', { ...B.fetchConfig(), body: JSON.stringify(payload) });
      this.state = json;
      if (json.sections) this.renderSections(json.sections);
      this.updateCount(json.item_count);
      document.dispatchEvent(new CustomEvent('cart:state', { detail: json }));
      return json;
    },
    update(payload) {
      return this.enqueue(() => this._update(payload));
    },
    // Called at the end of add/change tasks. Hooks enqueue follow-up work (never awaited here → no deadlock).
    hooks: [],
    mutated() { this.hooks.forEach((fn) => { try { fn(); } catch (e) { /* noop */ } }); },
    // Resolves once every queued cart task (including follow-up reconciliation) has finished.
    settle() { return this.queue.then(() => this.queue); },
    pendingVariants: new Set(),
    renderSections(sections) {
      Object.keys(sections).forEach((id) => {
        const target = document.getElementById(`shopify-section-${id}`);
        if (!target || !sections[id]) return;
        const doc = new DOMParser().parseFromString(sections[id], 'text/html');
        const fresh = doc.getElementById(`shopify-section-${id}`) || doc.body.firstElementChild;
        if (!fresh) return;
        const drawerWasOpen = target.querySelector('#CartDrawer.is-open');
        const hadFocus = !!(document.activeElement && target.contains(document.activeElement));
        const focusedId = hadFocus ? document.activeElement.id : null;
        target.innerHTML = fresh.innerHTML;
        target.querySelectorAll('.is-loading').forEach((el) => el.classList.remove('is-loading'));
        const newDrawer = target.querySelector('#CartDrawer');
        if (newDrawer && drawerWasOpen) {
          // Re-open the freshly rendered drawer without animation and rebind the open-drawer reference.
          newDrawer.classList.add('is-open'); newDrawer.setAttribute('aria-hidden', 'false');
          openDrawer = newDrawer; document.body.classList.add('drawer-open');
          document.querySelectorAll('[aria-controls="CartDrawer"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
        } else if (drawerWasOpen) {
          openDrawer = null; document.body.classList.remove('drawer-open');
        }
        const refocus = focusedId && target.querySelector('#' + CSS.escape(focusedId));
        if (refocus) refocus.focus();
        else if (newDrawer && drawerWasOpen) { const c = newDrawer.querySelector('.drawer__close'); c && c.focus(); }
        else if (hadFocus) { const h = target.querySelector('[data-cart-focus]'); h && h.focus(); }
      });
      document.dispatchEvent(new CustomEvent('cart:rendered'));
    },
    async refreshCount() {
      try { const r = await fetch(window.routes.cart_url + '.js'); const c = await r.json(); this.state = c; this.updateCount(c.item_count); return c; } catch (e) { return null; }
    },
    updateCount(n) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = n; });
    },
    open() {
      if (document.getElementById('CartDrawer')) B.openDrawer('CartDrawer');
    }
  };

  /* Quantity inputs */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const wrap = btn.closest('.quantity'); const input = wrap && wrap.querySelector('input');
    if (!input) return;
    const step = parseInt(btn.getAttribute('data-qty-change'), 10);
    const min = parseInt(input.min || '0', 10);
    let val = parseInt(input.value || '0', 10) + step;
    if (val < min) val = min;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart line changes (drawer + page) — keyed by line item key, never by index */
  async function changeLine(root, key, quantity) {
    root && root.classList.add('is-loading');
    try {
      await B.cart.change({ id: key, quantity });
    } catch (err) {
      // root may have been replaced by a re-render; look up the live element
      const liveRoot = document.querySelector('[data-cart-root]');
      const errEl = liveRoot && liveRoot.querySelector(`[data-line-error="${key}"]`);
      if (errEl) errEl.textContent = err.message; else alert(err.message);
    } finally {
      document.querySelectorAll('[data-cart-root].is-loading').forEach((el) => el.classList.remove('is-loading'));
    }
  }
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-quantity]');
    if (!input) return;
    changeLine(input.closest('[data-cart-root]'), input.getAttribute('data-line-key'), parseInt(input.value, 10) || 0);
  });
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-line-remove]');
    if (!btn) return;
    e.preventDefault();
    changeLine(btn.closest('[data-cart-root]'), btn.getAttribute('data-line-remove'), 0);
  });
  document.addEventListener('change', B.debounce(async (e) => {
    const note = e.target.closest('[data-cart-note]');
    if (!note) return;
    try { await B.cart.update({ note: note.value }); } catch (err) { /* note is non-critical */ }
  }, 400));

  /* Product forms (PDP, quick-add, outfit, lookbook) */
  const inFlight = new WeakSet();
  function labelEl(btn) { return btn ? (btn.querySelector('span') || btn) : null; }
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    const errorEl = form.querySelector('[data-form-error]');
    const idInput = form.querySelector('[name=id]');
    if (errorEl) errorEl.textContent = '';
    if (inFlight.has(form)) return;
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    if (!idInput || !idInput.value || idInput.disabled) { if (errorEl) errorEl.textContent = 'Please select an option.'; return; }
    // Guard across duplicate placements and re-rendered forms: one in-flight add per variant.
    const variantKey = String(idInput.value);
    if (B.cart.pendingVariants.has(variantKey)) return;
    B.cart.pendingVariants.add(variantKey);
    inFlight.add(form);
    const label = labelEl(btn);
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.setAttribute('data-busy', 'true'); }
    if (label) label.textContent = window.shopStrings.adding;
    let added = false;
    try {
      await B.cart.add(new FormData(form));
      added = true;
      if (label) label.textContent = window.shopStrings.added;
      // Adds made from inside the cart page refresh in place; everything else opens the drawer (or goes to /cart).
      if (!form.closest('[data-cart-section-id]')) {
        if (document.body.getAttribute('data-cart-type') === 'page') {
          await B.cart.settle(); // let offer-code evaluation finish before leaving the page
          window.location.href = window.routes.cart_url; return;
        }
        B.cart.open();
      }
    } catch (err) {
      if (errorEl) errorEl.textContent = err.message;
    } finally {
      inFlight.delete(form);
      B.cart.pendingVariants.delete(variantKey);
      const restore = () => {
        if (!btn) return;
        btn.removeAttribute('data-busy');
        // Ask the owning variant picker for the CURRENT state; fall back to enabled/default label.
        const restored = form.dispatchEvent(new CustomEvent('product-form:restore', { bubbles: true, cancelable: true }));
        if (restored) { btn.removeAttribute('aria-disabled'); if (label) label.textContent = btn.getAttribute('data-label') || window.shopStrings.addToBag; }
      };
      if (added) setTimeout(restore, 1200); else restore();
    }
  });

  /* Quick-add variant price: update the card price from the selected variant */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('select[data-qa-select]');
    if (!sel) return;
    const form = sel.closest('form');
    const json = form && form.querySelector('[data-qa-variants]');
    if (!json) return;
    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch (err) { return; }
    const scope = form.closest('[data-qa-scope]') || form;
    const priceEl = scope.querySelector('[data-qa-price]');
    const btn = form.querySelector('[type=submit]');
    const errorEl = form.querySelector('[data-form-error]');
    if (errorEl) errorEl.textContent = '';
    const v = variants.find((x) => String(x.id) === sel.value);
    if (priceEl && !priceEl.hasAttribute('data-original')) priceEl.setAttribute('data-original', priceEl.innerHTML);
    if (!v) {
      if (priceEl) priceEl.innerHTML = priceEl.getAttribute('data-original');
      if (btn && btn.getAttribute('data-busy') !== 'true') btn.removeAttribute('aria-disabled');
      return;
    }
    if (priceEl) {
      const money = B.formatMoney(v.price);
      priceEl.innerHTML = v.compare_at_price && v.compare_at_price > v.price
        ? `<span class="price"><span class="price__sale">${money}</span><s class="price__compare"><span class="visually-hidden">Was </span>${B.formatMoney(v.compare_at_price)}</s></span>`
        : `<span class="price"><span>${money}</span></span>`;
    }
    if (btn && btn.getAttribute('data-busy') !== 'true') {
      if (v.available) btn.removeAttribute('aria-disabled'); else btn.setAttribute('aria-disabled', 'true');
    }
    if (!v.available && errorEl) errorEl.textContent = window.shopStrings.soldOut;
  });

  /* Localization form auto-submit */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-localization-select]');
    if (!sel) return;
    const form = sel.closest('form');
    const hidden = form.querySelector(`input[name="${sel.getAttribute('data-localization-select')}"]`);
    if (hidden) hidden.value = sel.value;
    form.submit();
  });

  /* Details-based dialogs */
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-dialog-open]');
    if (open) { const d = document.getElementById(open.getAttribute('data-dialog-open')); if (d && d.showModal) { d.showModal(); } return; }
    const close = e.target.closest('[data-dialog-close]');
    if (close) { const d = close.closest('dialog'); d && d.close(); }
  });
  document.addEventListener('click', (e) => {
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  /* Sticky ATC visibility on mobile */
  const stickyAtc = document.querySelector('.sticky-atc');
  if (stickyAtc && 'IntersectionObserver' in window) {
    const target = document.querySelector('[data-main-atc]');
    if (target) {
      new IntersectionObserver((entries) => {
        entries.forEach((en) => stickyAtc.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0));
      }).observe(target);
    }
  }

  /* Shopify editor: open drawer when section selected */
  document.addEventListener('shopify:section:select', (e) => {
    const sec = e.target;
    if (sec.querySelector('#CartDrawer')) B.openDrawer('CartDrawer');
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    if (e.target.querySelector('#CartDrawer')) B.closeDrawer('CartDrawer', false);
  });
})();
